<template>
  <div style="margin:20px 0px;">
    <div v-if="taskIdExist&&showWorkFlow" style="min-height:120px;">
      <van-form label-width="70px" label-align="right" style="margin-bottom:20px;">
        <van-cell-group inset>
          <van-field type="textarea" label="审批意见：" v-model="comment" placeholder="请输入意见（注意，意见内容请勿包含&字符）" rows="2" autosize maxlength="1000"/>
        </van-cell-group>
      </van-form>
      <van-button @click="approve('disagreeReject')" style="margin:0 10px;" plain size="small" round type="danger" loading-text="加载中。。。">驳回</van-button>
      <van-button @click="approve('agreeSubmit')" style="margin:0 10px;" plain size="small" round type="info" loading-text="加载中。。。">通过</van-button>
      <van-dialog v-model="showRefund" title="选择驳回的节点" show-cancel-button @cancel="showRefund = false" @confirm="confirmReject">
        <div style="padding:20px;">
          <van-radio-group v-model="reFundSid">
            <van-radio v-for="reject in workFlowReFundList" :key="reject" :name="reject.userTaskId" style="margin:10px;">
              <div
                v-for="(person,index) in reject.userList"
                :key="person.userId"
                class="mb5 exam"
                style="float:left;margin:0 10px 0 0;"
              >
                  <span class="mr5">{{person.userName}}</span>
                  <span v-if="index==0">起草</span>
                  <span v-else>同意</span>
              </div>
            </van-radio>
          </van-radio-group>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import Cookie from 'js-cookie'
import DateUtils from "@/plugins/DateUtils.vue";
//引入组织人员组件
import WorkFlowOrgPersonSelectList from "../plugins/WorkFlowOrgPersonSelectList";
export default {
  data() {
    return {
      parentId:"50020020",//50020020 集团  50652940 审计监察总部
      showRefund: false, //是否显示驳回窗口
      reFundSid: "", //驳回的sid
      loading: true,
      showSelectPerson: false, //是否显示选人弹窗
      selectPersonValue: [], //选人弹窗的默认人员传入
      multipleSelect: true, //选人弹窗是否多选
      defaultExpandKeys: ["50652940"], //选人弹窗默认展开的节点
      nodeOperation: "", //add edit
      nodeOperationSid: "", //操作节点sid
      isTransfer: false, //是否转签操作
      isShowTransfer:false,//是否显示转签操作
      showHistory: "none", //是否显示审批历史
      workFlowEntity: [], //工作流实体对象存放
      selectOperationValue: "agreeSubmit", //默认的意见操作
      oguName: "", //当前审批人
      orgUserGuid: "", //当前审批人工号
      nowDate: "", //当前时间
      comment: "", //当前审批人具体意见
      taskId: "", //当前用户在此工作流的任务ID（如果没有任务，为空）
      showSaveButtonVal:false,//是否显示保存按钮
      deployWorkFlow:true,//是否在获取时部署
      confirmTxt:"确定",
      taskEventData:{},
      hasBS:'',
      currTaskSidNum: "",
      userListYesNum: "",
      secondNode: false, // 后端返回是否为第2节点
      reFundFast: false, // 前端判断是否可快速驳回
      reFundFastSid: "",
      manualCalBackNum:0,
      lastSaveTime:0,
      historyInfo:[]
    };
  },
  computed: {
    //操作意见
    selectOperation:function(){
       if(this.workFlowEntity.startUserTaskSid==this.workFlowEntity.currUserTaskSid||this.mustAgree){
         return [
        { value: "agreeSubmit", name: "同意并送签" }
      ];
       }else{
          return [
        { value: "agreeSubmit", name: "同意并送签" },
        { value: "disagreeReject", name: "不同意并驳回" },
      ];
       }

    },
    //是否当前用户的任务
    taskIdExist: function () {
      if (
        this.taskId != null &&
        this.taskId != "" &&
        this.taskId != undefined
      ) {
        return true;
      } else {
        return false;
      }
    },
    //是否显示撤回按钮
    isReCall: function () {
      try {
        let firstUGuid = this.workFlowEntity.userListYes[0].userList[0].userId;
        let uGuid = this.workFlowEntity.uGuid;
        if (
          uGuid == firstUGuid &&
          this.workFlowEntity.endFlow == "" &&
          this.workFlowEntity.currUserTaskSid !=
            this.workFlowEntity.startUserTaskSid
        ) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    //驳回可选择的节点
    workFlowReFundList: function () {
      let reFundList = [];
      try {
        for (let i = 0; i < this.workFlowEntity.userListYes.length; i++) {
          if(this.workFlowEntity.currUserTaskSid==this.workFlowEntity.userListYes[i].userTaskId){
            break;
          }else{
            reFundList.push(this.workFlowEntity.userListYes[i]);
          }

        }
      } catch (error) {}

      return reFundList;
    },
  },
  props: {
    workFlowGuid: String,
    workFlowFormKey: String,
    taskSubject: String,
    taskUrl: String,
    // 搭配 @cancelApproval(wfGuid)
    canCancel:{
      type:Boolean,
      default:false
    },
    showWorkFlow:{
      type:Boolean,
      default:true
    },
    //废弃流程用 废弃状态
    businessType:{
      type:String,
      default:null
    },
    workFlowFormVar:{
      type:Object,
      default(){
        return {}
      }
    },
    workFlowFormData:{
      type:Object,
      default(){
        return {}
      }
    },
    showSaveButton:{
      type:Boolean,
      default:false
    },
    businessGuid:String,
    submitLoading:{
      type:Boolean,
      default:false
    },
    mustAgree:{
      type:Boolean,
      default:false
    },
    showOperate:{
      type:Boolean,
      default:true
    },
    notSendMsg:{
      type:Boolean,
      default:false
    },
    sendFsApprove:{
      type:Boolean,
      default:false
    }
  },
  created() {},
  mounted() {
    this.ACT_getWorkFlow();
  },
  methods: {
    //手动回调 连续点击5次 admin可操作
    manualCalBack(){
      if(Cookie.get('isAdmin')){
        this.manualCalBackNum+=1
        console.log('点击')
        if(this.manualCalBackNum==5){
          console.log(this.manualCalBackNum+'次')
          
          this.$confirm('确定重新回调审批完成函数吗？','提示',{
            closeOnClickModal:false,
          }).then(()=>{
            this.manualCalBackNum = 1000000
            this.$emit('sendWorkFlow',1);
          }).catch(()=>{

          })
        }else if(this.manualCalBackNum==1){
          let intval = setInterval(()=>{
            console.log('消除',this.manualCalBackNum)
            this.manualCalBackNum -= 1
            if(this.manualCalBackNum==0){
              clearInterval(intval)
            }
          },1000)
        }
      }
    },
    //取消流程
    cancelApproval(){
      this.$confirm('此操作将废弃当前流程，是否继续？','提示'
          ,{
              confirmButtonText:'确定',
              cancelButtonText:'取消',
              type:'warning'
          }).then(()=>{
            this.directCancelApproval()
          })
    },
    directCancelApproval(){
      this.$http.post('/api/activiti/v0.1/abandoned/save',{businessGuid:this.businessGuid,wfGuid:this.workFlowGuid,businessType:this.businessType})
      .then(res=>{
        if(res.data&&res.data>0){
          this.$emit('cancelApproval',this.workFlowGuid)
        }else{
          this.$message.error('废弃失败！请联系管理员');
        }
      })
    },
    //保存表单数据回调
    saveFormData(){
      let curTime = new Date().getTime()
      if(curTime-this.lastSaveTime<3000){
        return this.$message.info('保存过快，请 '+Math.ceil(3-(curTime-this.lastSaveTime)/1000)+' 秒后再操作');
      }
      
       this.$emit("saveFormData",true);
       this.lastSaveTime = curTime
    },
    rejectToFast(comment){
      this.comment = comment
      this.reFundFastSid = this.workFlowEntity.startUserTaskSid
      this.confirmFastReject()
    },
    //确认驳回操作
    confirmReject() {
      console.log(this.workFlowEntity,"数据")
      console.log(this.reFundSid,"驳回点user")
      console.log( this.workFlowEntity.startUserTaskSid,"工作流起点用户")
      this.loading = true;
      this.$http
        .post(
          "/api/activiti/v0.1/workflow/operationReject",
          this.$qs.stringify({
            businessKey: this.workFlowGuid,
            taskId: this.taskId,
            toactusertasksid: this.reFundSid,
            comment: this.comment,
            sendFsApprove:this.sendFsApprove
          })
        )
        .then(async (res) => {
          var js = res.data;
          if (js.errcode == 0) {
            this.showRefund = false;
            
            let workFlowstatus=js.data.workFlowStatus;
            //驳回后的操作
            this.$emit('sendWorkFlow',workFlowstatus, '驳回'); // 直接修改父组件的属性
            if(this.reFundSid == this.workFlowEntity.startUserTaskSid){
              this.$emit('workflowReject',workFlowstatus, '驳回');
            }
            this.showSaveButtonVal = false
            this.loading = false;
            this.ACT_getWorkFlow();
          } else {
            this.loading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }

        }).catch(err=>{
          this.showRefund = false;
          this.ACT_getWorkFlow();
          this.$emit('sendWorkFlow',0); // 直接修改父组件的属性
          if(this.reFundSid == this.workFlowEntity.startUserTaskSid){
            this.$emit('workflowReject',0);
          }
          this.loading = false;
        });
        //解决驳回后端处理后 但不返回数据导致前端无反应bug
        setTimeout(()=>{
          if(this.showRefund){
            this.showRefund = false;
            this.ACT_getWorkFlow();
            this.$emit('sendWorkFlow',0); // 直接修改父组件的属性
            if(this.reFundSid == this.workFlowEntity.startUserTaskSid){
              this.$emit('workflowReject',0);
            }
            this.loading = false;
          }
        },2500)
    },
    //确认驳回操作
    confirmFastReject() {
      console.log("驳回操作")
      this.$http
        .post(
          "/api/activiti/v0.1/workflow/operationReject",
          this.$qs.stringify({
            businessKey: this.workFlowGuid,
            taskId: this.taskId,
            toactusertasksid: this.reFundFastSid,
            comment: this.comment,
            sendFsApprove:this.sendFsApprove
          })
        )
        .then(async (res) => {
          var js = res.data;
          if (js.errcode == 0) {
            this.showRefund = false;
            
            let workFlowstatus=js.data.workFlowStatus;
            //驳回后的操作
            this.$emit('sendWorkFlow',workFlowstatus, '驳回'); // 直接修改父组件的属性
            this.$emit('workflowReject',workFlowstatus,"驳回废弃");
            this.showSaveButtonVal = false
            this.loading = false;
            this.ACT_getWorkFlow();
          } else {
            this.loading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }


        }).catch(err=>{
          this.showRefund = false;
          this.ACT_getWorkFlow();
          this.$emit('sendWorkFlow',0); // 直接修改父组件的属性
          this.$emit('workflowReject',0);
          this.loading = false;
        });
        //解决驳回后端处理后 但不返回数据导致前端无反应bug
        setTimeout(()=>{
          // if(this.showRefund){
            this.showRefund = false;
            this.ACT_getWorkFlow();
            this.$emit('sendWorkFlow',0); // 直接修改父组件的属性
            this.$emit('workflowReject',0);
            this.loading = false;
          // }
        },2500)
    },
    showOrgPersonFunction(val){
      this.showSelectPerson=val;
    },
    //默认节点选择的人
    getSelectPersonValue(val) {
      this.selectPersonValue = val;
    },
    //获取传入节点在当前任务节点前后的位置
    nodeDirectClass(sid) {
      if (this.workFlowEntity.endFlow == "endFlow") return "com";
      let arr = new Array();
      for (let i = 0; i < this.workFlowEntity.userListYes.length; i++) {
        arr.push(this.workFlowEntity.userListYes[i].userTaskId);
      }
      let sidIndex = arr.indexOf(sid);
      let currIndex = arr.indexOf(this.workFlowEntity.currUserTaskSid);
      if (sidIndex < currIndex) {
        return "com";
      } else if (sidIndex == currIndex) {
        return "curstep";
      } else {
        return "";
      }
    },
    //获取工作流
    async ACT_getWorkFlow() {
      if(!this.workFlowGuid||!this.workFlowFormKey){
        this.loading=false;
        return;
      }

      await this.$http
        .get("/api/activiti/v0.1/workflow/getWorkFlow",{
          params:{
            businessKey:this.workFlowGuid,
            formKey:this.workFlowFormKey,
            formVar:JSON.stringify(this.workFlowFormVar),
          }
        })
        .then(async (res) => {
          var js = res.data;
          if (js.errcode == 0) {
            this.workFlowEntity = js.data;
            this.workFlowEntity.userListYes = this.workFlowEntity.userListYes.map(item=>{
              let arr = new Array();
              for (let i = 0; i < this.workFlowEntity.userListYes.length; i++) {
                arr.push(this.workFlowEntity.userListYes[i].userTaskId);
              }
              let sidIndex = arr.indexOf(item.userTaskId);
              let currIndex = arr.indexOf(this.workFlowEntity.currUserTaskSid);
              if(sidIndex - currIndex == 1&&((!item.userList)||item.userList.length<1)){
                item.curNodeEditColor = 'red'
              }
              return item
            })
            this.historyInfo = this.workFlowEntity.historyInfo.sort(()=>{return -1})
            console.log(this.historyInfo,666);
            this.oguName = this.workFlowEntity.userInfo.oguName;
            this.orgUserGuid = this.workFlowEntity.userInfo.orgUserGuid;
            this.nowDate = this.workFlowEntity.nowDate;
            this.taskId = this.workFlowEntity.taskId;
            this.currTaskSidNum = this.workFlowEntity.currTaskSidNum;
            this.userListYesNum = this.workFlowEntity.userListYesNum;
            this.secondNode = this.workFlowEntity.secondNode;
            this.reFundFastSid = this.workFlowEntity.reFundSid;
            if(js.data.workFlowStatus==0){
              this.confirmTxt="提交";
            }
            if(!js.data.beCurrUser && js.data.workFlowStatus==0) {
                this.$emit('workFlowStatus', -1); // 把工作流状态传给父组件
            } else {
                this.$emit('workFlowStatus', js.data.workFlowStatus); // 把工作流状态传给父组件
            }

            this.$emit('workFlowNode',js.data.userListYes,js.data.currUserTaskSid,js.data.uGuid,js.data.workFlowStatus);
            let allApprovalUserIds = []
            let allApprovalUserNos = []
              js.data.userListYes.forEach((item,index)=>{
                if(index!=0){
                  item.userList.forEach(item1=>{
                    allApprovalUserIds.push(item1.userName)
                    allApprovalUserNos.push(item1.orgUserGuid)
                  })
                }
                if(js.data.currTaskSidNum==item.nodeNum&&js.data.userListYes.length>(index+1)){
                  let user = js.data.userListYes[index+1]
                  this.taskEventData.afterTaskUser = user.userList.map(item=>{
                    return item.orgUserGuid
                  }).join(',')
                  this.taskEventData.afterTaskTitle = user.userTitle
                }
              })
            this.taskEventData.allApprovalUserIds=allApprovalUserIds
            this.taskEventData.allApprovalUserNos=allApprovalUserNos
            this.taskEventData.workFlowStatus = js.data.workFlowStatus
            let curName = Cookie.get('oguName')
            let curTask = js.data.userListYes.find((item,index)=>{
                return item.nodeNum == js.data.currTaskSidNum
            })
            console.log(curTask,"看看")
            console.log(js.data,"测试数据")
            this.taskEventData.curTaskTitle = (curTask?curTask.userTitle:'')
            this.taskEventData.curTaskIsFirst = js.data.currUserTaskSid == js.data.startUserTaskSid
            this.taskEventData.firstTaskUser=js.data.userListYes[0].userList[0].userName == curName&&this.taskEventData.curTaskIsFirst
            this.taskEventData.firstUser = js.data.userListYes[0].userList[0].orgUserGuid
            if(js.data.userListYes[js.data.userListYesNum-1].userList.length > 0){
              this.taskEventData.lastTaskUser = js.data.userListYes[js.data.userListYesNum-1].userList[0].userName == curName?true:false
            }else {
              this.taskEventData.lastTaskUser = false;
            }

            console.log(js.data,"测试数据")
            this.taskEventData.isTask = js.data.taskId?true:false
            console.log(this.taskEventData,"看看数据")
            this.taskEvent()
            this.loading = false;
          } else if (js.errcode == 102) {
            //没有此流程就部署流程
            if(this.deployWorkFlow&&this.hasBS!=this.workFlowGuid){
              // this.hasBS = this.workFlowGuid
             await this.ACT_Deploy();
            }

          } else {
            this.loading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });
    },
    approve(operation){
      this.selectOperationValue=operation
      if(operation=='disagreeReject'&&(!this.secondNode)){
        this.ACT_confirm()
      }else{
        let approveMsg = operation=='agreeSubmit'?'同意':'驳回'
        this.Dialog.confirm({
          title:'提示',
          message:'您好！请确认【'+approveMsg+'】'
        }).then(async ()=>{
          this.ACT_confirm()
        })
      }
      
    },
    taskEvent(){
      if(!this.taskEventData.hasOwnProperty('firstUser')){
        return
      }
      this.taskEventData.showSaveButton=this.showSaveButtonVal
      this.$emit('taskEvent',this.taskEventData)
      //当前节点信息

    },
    //部署工作流
    ACT_Deploy() {
      //此变量定义勿动
      let subject={
          "taskSubject":this.taskSubject,
          "taskUrl":this.taskUrl
         }

      let json=new Object;
      json.subject=JSON.stringify(subject);
      if(this.workFlowFormVar){
          for (var key in this.workFlowFormVar)
          {
              json[key]=this.workFlowFormVar[key];
          }
      }
      //deploy url
      let deployUrl="/api/activiti/v0.1/workflow/deploy?tenant=portal"
                    +"&businessKey="+this.workFlowGuid
                    +"&formKey="+this.workFlowFormKey;
      //变量存放
      this.$http
        .post(deployUrl, json)
        .then(async (res) => {
          var js = res.data;
          if (js.errcode == 0) {
            this.ACT_getWorkFlow();
            this.loading = false;
          } else {
            this.loading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });
    },
    //显示审批历史记录
    ACT_viewHistory() {
      this.showHistory = "";
    },
    //关闭审批历史记录
    ACT_closeHistory() {
      this.showHistory = "none";
    },
    //添加节点
    addActiviti(sId) {
      this.selectPersonValue = [];
      this.nodeOperation = "add";
      this.nodeOperationSid = sId;
      this.showSelectPerson = true;
    },
    //通过节点下标编辑节点
    editActivitiByIndex(index,selectUser){
      if(this.workFlowEntity.userListYes[index]){
        this.selectPersonValue = selectUser;
        let sId = this.workFlowEntity.userListYes[index].userTaskId
        let userList = this.workFlowEntity.userListYes[index].userList
        let arr = new Array();
        if (userList != null) {
          for (let i = 0; i < userList.length; i++) {
            arr.push(userList[i].userId);
          }
        }
        arr.push(...selectUser)
        this.selectPersonValue = Array.from(new Set(arr));
        this.nodeOperation = "edit";
        this.nodeOperationSid = sId;
        this.confirmSelectPerson()
      }else{
        console.log('代码错误')
      }
    },
    //编辑节点
    editActiviti(sId, userList) {
      let arr = new Array();
      if (userList != null) {
        for (let i = 0; i < userList.length; i++) {
          arr.push(userList[i].userId);
        }
      }
      this.selectPersonValue = arr;
      this.nodeOperation = "edit";
      this.nodeOperationSid = sId;
      this.showSelectPerson = true;
    },
    //删除节点
    delActiviti(sId) {
      this.$confirm("你确认要删除吗?", "提示", {})
        .then(() => {
          this.$http
            .post(
              "/api/activiti/v0.1/workflow/deleteUser",
              this.$qs.stringify({
                businessKey: this.workFlowGuid,
                actUserTaskId: sId,
              })
            )
            .then(async (res) => {
              var js = res.data;
              if (js.errcode == 0) {
                this.ACT_getWorkFlow();
                this.loading = false;
              } else {
                this.$message({
                  showClose: true,
                  message: js.errmsg,
                  type: "error",
                });
              }
            });
        })
        .catch(() => {});
    },
    curNodeEditPerson(nodeTitle,users){
      if(!nodeTitle){
        return this.$message.error('请联系管理员配置当前节点信息')
      }
      this.selectPersonValue = users
      this.nodeOperation = 'edit'
      let node = this.workFlowEntity.userListYes.find(item=>item.userTitle==nodeTitle)
      if(!node){
        return this.$message.error('请联系管理员配置当前节点信息')
      }
      this.nodeOperationSid = node.userTaskId
      this.confirmSelectPerson()
    },
    //选人人员确认
    confirmSelectPerson() {
      if (
        this.selectPersonValue == null ||
        this.selectPersonValue == "" ||
        this.selectPersonValue == undefined
      ) {
        this.$message({
          showClose: true,
          message: "请选择人员",
          type: "error",
        });
        return;
      }

      if (this.nodeOperation == "add") {
        //加人操作
        this.$http
          .post(
            "/api/activiti/v0.1/workflow/addUser",
            this.$qs.stringify({
              businessKey: this.workFlowGuid,
              actUserTaskId: this.nodeOperationSid,
              assignee: this.selectPersonValue.join(","),
            })
          )
          .then(async(res) => {
            var js = res.data;
            if (js.errcode == 0) {
              this.ACT_getWorkFlow();
              this.loading = false;
            } else {
              this.$message({
                showClose: true,
                message: js.errmsg,
                type: "error",
              });
            }
          });
        this.showSelectPerson = false;
      } else if (this.nodeOperation == "edit") {
        //编辑操作
        this.$http
          .post(
            "/api/activiti/v0.1/workflow/updateUser",
            this.$qs.stringify({
              businessKey: this.workFlowGuid,
              actUserTaskId: this.nodeOperationSid,
              assignee: this.selectPersonValue.join(","),
            })
          )
          .then(async (res) => {
            var js = res.data;
            if (js.errcode == 0) {
              this.ACT_getWorkFlow();
              this.loading = false;
            } else {
              this.$message({
                showClose: true,
                message: js.errmsg,
                type: "error",
              });
            }
          });
        this.showSelectPerson = false;
      } else if (this.nodeOperation == "transfer") {
        this.$confirm("你确认要转移任务吗?", "提示", {})
          .then(() => {
            this.$http
              .post(
                "/api/activiti/v0.1/workflow/transferUser",
                this.$qs.stringify({
                  businessKey: this.workFlowGuid,
                  taskId: this.taskId,
                  touguid: this.selectPersonValue.join(","),
                })
              )
              .then(async(res) => {
                var js = res.data;
                if (js.errcode == 0) {
                  this.showSelectPerson = false;
                  this.ACT_getWorkFlow();
                  this.loading = false;
                } else {
                  this.$message({
                    showClose: true,
                    message: js.errmsg,
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {});
      }
    },
    //确认送签
    ACT_confirm(comment) {
      if(comment){
        this.comment = comment
      }
      if (!this.taskId) {
        this.$message({
          showClose: true,
          message: "您没有此任务，不能操作。",
          type: "error",
        });
        return;
      }

      //驳回操作判断
      if (this.selectOperationValue == "disagreeReject") {
          if(!this.secondNode) {
              this.showRefund = true
          } else {
              this.reFundFast = true
              this.confirmFastReject()
          }
          return;
      }

      if(this.secondNode && this.reFundFast) {
        this.confirmFastReject()
        return;
      }

      //送签前调用父窗口进行业务校验
      // let callWorkFlowFormResult={
      //   errcode:0,
      //   errmsg:''
      // };
      if(this.$listeners.callWorkFlowForm){
        this.$emit('callWorkFlowForm',true,(val)=>{
          if(val.errcode!=0){
            if(val.errmsg){
            this.$message({
                showClose: true,
                message: val.errmsg,
                type: "error",
              });
            }
            return;
          }else{
            this.tjsq()
          }
        });
      }else{
        this.tjsq()
      }
    },

    tjsq(){
      this.loading = true;
      //送签操作
      this.$http
        .post(
          "/api/activiti/v0.1/workflow/operationSend",
          this.$qs.stringify({
            businessKey: this.workFlowGuid,
            formKey:this.workFlowFormKey,
            taskId: this.taskId,
            selectOperation: this.selectOperationValue,
            comment: this.comment,
            formVar:JSON.stringify(this.workFlowFormVar),
            formData:JSON.stringify(this.workFlowFormData),
            jsonDatas:this.taskSubject,
            notSendMsg:this.notSendMsg,
            sendFsApprove:this.sendFsApprove,
            formKey:this.workFlowFormKey
          })
        )
        .then(async(res) => {

          var js = res.data;
          if (js.errcode == 0||(!js.errmsg)) {
            this.ACT_getWorkFlow();
            let workFlowstatus=js.data.workFlowStatus;
            //送完后的操作
            this.$emit('sendWorkFlow',workFlowstatus); // 直接修改父组件的属性
            //解决接口报404后不刷新浏览器bug 导致还存在保存按钮
            this.showSaveButtonVal = false
            this.loading = false;
            
          } else {
            this.loading = false;
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        }).catch(err=>{
          console.log('审批报错.....',err);
          if(this.workFlowEntity.currUserTaskSid==this.workFlowEntity.userListYes[this.workFlowEntity.userListYes.length-1].userTaskId){
            //送完后的操作
            this.$emit('sendWorkFlow',1); // 直接修改父组件的属性
            //解决接口报404后不刷新浏览器bug 导致还存在保存按钮
            this.showSaveButtonVal = false
            this.loading = false;
          }
        });
        setTimeout(()=>{
          console.log('审批超时......');
          if(this.loading){
            if(this.workFlowEntity.currUserTaskSid==this.workFlowEntity.userListYes[this.workFlowEntity.userListYes.length-1].userTaskId){
              //送完后的操作
              this.$emit('sendWorkFlow',1); // 直接修改父组件的属性
              //解决接口报404后不刷新浏览器bug 导致还存在保存按钮
              this.showSaveButtonVal = false
              this.loading = false;
            }
          }
        },2500)
    },
    //转签操作
    transferActiviti() {
      this.multipleSelect = false;
      this.selectPersonValue = [];
      this.nodeOperation = "transfer";
      this.showSelectPerson = true;
    },
    //撤回操作
    ACT_recall() {
      this.$confirm("你确认要撤回吗?", "提示", {})
        .then(() => {
          this.$http
            .post(
              "/api/activiti/v0.1/workflow/callBack",
              this.$qs.stringify({
                businessKey: this.workFlowGuid,
              })
            )
            .then(async (res) => {
              var js = res.data;
              if (js.errcode == 0) {
                
                 let workFlowstatus=js.data.workFlowStatus;
                 //撤回后的操作
                 this.$emit('sendWorkFlow',workFlowstatus, '撤回'); // 直接修改父组件的属性
                 this.ACT_getWorkFlow();
                //  this.showSaveButtonVal = false
                this.changeShowSaveButton()
                this.loading = false;
              } else {
                this.$message({
                  showClose: true,
                  message: js.errmsg,
                  type: "error",
                });
              }
            }).catch(err=>{
              this.ACT_getWorkFlow();
              this.$emit('sendWorkFlow',0); // 直接修改父组件的属性
              this.loading = false;
            });

            this.setTimeout(()=>{
              if(this.loading){
                this.ACT_getWorkFlow();
                this.$emit('sendWorkFlow',0); // 直接修改父组件的属性
                this.loading = false;
              }
            },2500)
        })
        .catch(() => {});
    },

    updateUser(title,user){
      if(!title&&!user){
        return
      }
      let node = workFlowEntity.userListYes.find(item=>{
        return item.userTitle == title
      })
      if(node){
        this.$http
        .post(
          "/api/activiti/v0.1/workflow/updateUser",
          this.$qs.stringify({
            businessKey: this.workFlowGuid,
            actUserTaskId: node.userTaskId,
            assignee: user,
          })
        )
        .then(async (res) => {
          var js = res.data;
          if (js.errcode == 0) {
            this.ACT_getWorkFlow();
            this.loading = false;
          } else {
            this.$message({
              showClose: true,
              message: js.errmsg,
              type: "error",
            });
          }
        });
      }
    },
    changeShowSaveButton(){
      if(this.taskId){
        this.showSaveButtonVal=this.showSaveButton;
        this.$emit('isShowDisabled', this.showSaveButtonVal); //审批人驳回后，没有保存按钮，则设置表单不可编辑
      }else{
        this.showSaveButtonVal=false;
        this.$emit('isShowDisabled', this.showSaveButtonVal); //审批人驳回后，没有保存按钮，则设置表单不可编辑
      }
      this.taskEvent()
    }
  },
  filters: {
    formatDate(time) {
      return DateUtils.formatDate(time, "YYYY-MM-DD HH:mm:ss");
    },
  },
  watch:{
    workFlowGuid(){
      this.ACT_getWorkFlow();

    },
    workFlowFormVar:{
      deep:true,
      handler:function(val,old){
        console.log("workFlowFormVar",val,old)
        //this.deployWorkFlow=false
        this.ACT_getWorkFlow();
      }
    },
    showSaveButton:{
      immediate:true,
      handler(val){
        this.changeShowSaveButton()
      }
    },
  },
  //注册组件
  components: {
    WorkFlowOrgPersonSelectList, //组织人员数
  },
};
</script>
<style scoped>
@import "../assets/css/mainbody-sj.css";
.activiti_opinion {
  width: 140px;
  word-break: break-all;
  display: -webkit-box; /**对象作为伸缩盒子模型展示**/
  -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
  -webkit-line-clamp: 1; /**显示的行数**/
  overflow: hidden; /**隐藏超出的内容**/
}
.content_act {
  background-color: #ffffff;
  padding: 20px;
}
.w150 {
  width: 150px;
}
.el-dialog__title {
  float: left;
}
.aaa {
  float: left;
  padding: 5px 10px 5px 10px;
  cursor: pointer;
  background-color: #499cd3;
  color: #ffffff;
}
.no_aaa {
  padding: 5px 10px 5px 10px;
  float: left;
  cursor: pointer;
  background-color: #22578c;
  color: #ffffff;
}
.divWidth {
  width: 183px;
  overflow: hidden;
}

.hisRejectTb th,.hisRejectTb td{
  border: 1px solid gray;
}
</style>
